var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    y: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#A884C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1671 26.5H34.9004C33.5936 26.5 32.9397 26.5 32.4406 26.2456C32.0015 26.0219 31.6449 25.665 31.4211 25.226C31.1668 24.7268 31.1668 24.0735 31.1668 22.7667V19.5M38.1668 36.7667V26.8798C38.1668 26.309 38.1664 26.0236 38.1019 25.7551C38.0447 25.517 37.9506 25.2894 37.8227 25.0807C37.6784 24.8452 37.4772 24.6434 37.0736 24.2399L33.4272 20.5935C33.0237 20.1899 32.8219 19.9882 32.5864 19.8439C32.3777 19.7159 32.1501 19.6216 31.912 19.5645C31.6435 19.5 31.358 19.5 30.7873 19.5H25.5671C24.2603 19.5 23.6064 19.5 23.1073 19.7543C22.6682 19.978 22.3115 20.335 22.0878 20.774C21.8335 21.2732 21.8335 21.9266 21.8335 23.2333V36.7667C21.8335 38.0735 21.8335 38.7268 22.0878 39.226C22.3115 39.665 22.6682 40.0219 23.1073 40.2456C23.6064 40.5 24.2603 40.5 25.5671 40.5H34.4337C35.7405 40.5 36.3935 40.5 36.8926 40.2456C37.3316 40.0219 37.6891 39.665 37.9128 39.226C38.1671 38.7268 38.1668 38.0735 38.1668 36.7667Z",
    stroke: "#A884C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 36H30.005",
    stroke: "#A884C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30V32.4",
    stroke: "#A884C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiring);
export default __webpack_public_path__ + "static/media/expiring.81442770f9677ec5306d2c895aee9729.svg";
export { ForwardRef as ReactComponent };